<template>
  <div
    :id="barchart_id"
    class="nvd3-line bar-chart text-center"
    data-x-grid="false"
  >
    <svg></svg>
  </div>
</template>

<script>
import $ from "jquery";
import * as d3 from "d3";
import * as nv from "nvd3/build/nv.d3.min.js";

export default {
  name: "bar_chart",
  props: {
    topik: Array,
    series: Array,
    barchart_id: {
      type: String,
      default: function () {
        return "chart1";
      },
    },
  },
  data() {
    return {
      data_topik: this.topik,
      data_series: this.series,
    };
  },
  methods: {
    loadChart: function () {
      var keyword = this.data_topik;
      let rotate_label = 0;
      if (this.data_topik) {
        if (this.data_topik.length > 5) {
          rotate_label = -30;
        }
      }

      let margin;
      margin = {
        left: 50,
        bottom: 100,
      };
      var data = this.data_series;
      nv.addGraph(() => {
        var chart = nv.models
          .multiBarChart()
          .reduceXTicks(false)
          .rotateLabels(rotate_label)
          .showControls(true)
          .groupSpacing(0.05)
          .stacked(true)
          .color([
            $("body").css("--success"),
            "#0e6d87",
            $("body").css("--danger"),
          ])
          .margin(margin);
        chart.xAxis
          .tickValues(function () {
            let arr = [];
            for (let key in keyword) {
              arr[key] = parseInt(key);
            }
            return arr;
          })
          .tickFormat(function (d) {
            if (keyword.length == 1) {
              return keyword[0].nama;
            } else {
              if (keyword[d]) {
                return keyword[d].nama;
              } else {
                return "";
              }
            }
          });

        chart.yAxis.tickFormat(d3.format("."));
        d3.select("#chart1 svg").datum(data).call(chart);
        nv.utils.windowResize(chart.update);

        return chart;
      });
    },
  },
  mounted: function () {
    if (this.series != null) {
      this.loadChart();
    }
  },
};
</script>

<style scoped>
@import "~nvd3/build/nv.d3.min.css";
.nvd3-svg {
  height: 385px !important;
}
</style>